import React, { useState } from 'react';
import { ChevronDownIcon, ChevronUpIcon, HelpCircleIcon } from 'lucide-react';
const faqs = [{
  question: 'What are essential oils?',
  answer: 'Essential oils are concentrated plant extracts that retain the natural smell and flavor, or "essence," of their source. They are obtained through distillation or mechanical methods, such as cold pressing.'
}, {
  question: 'How do I use essential oils?',
  answer: 'Essential oils can be used in various ways: through diffusion in the air, topical application when properly diluted with a carrier oil, or in some cases, internal consumption (only when specifically labeled as food grade).'
}, {
  question: 'Are your essential oils 100% pure?',
  answer: 'Yes, all our essential oils are 100% pure with no additives or fillers. We conduct rigorous testing to ensure the highest quality and purity of each batch.'
}, {
  question: 'How should I store my essential oils?',
  answer: 'Store essential oils in dark glass bottles in a cool, dry place away from direct sunlight. Properly stored, most essential oils can maintain their potency for 1-2 years or longer.'
}, {
  question: 'Do you ship internationally?',
  answer: 'Yes, we ship to select countries internationally. Shipping rates and delivery times vary by location. Please check our shipping policy for more details.'
}];
const FaqSection = () => {
  const [openIndex, setOpenIndex] = useState(0);
  const toggleFaq = (index: number) => {
    setOpenIndex(openIndex === index ? -1 : index);
  };
  return <section className="py-20 bg-white" data-id="element-184">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-185">
        <div className="text-center mb-12" data-id="element-186">
          <div className="inline-flex items-center px-4 py-2 bg-[#f0f7eb] text-[#2e7d32] text-sm font-medium rounded-full mb-4" data-id="element-187">
            <HelpCircleIcon className="h-4 w-4 mr-2" data-id="element-188" />
            <span data-id="element-189">Questions & Answers</span>
          </div>
          <h2 className="text-3xl font-bold text-gray-900 mb-4" data-id="element-190">
            Frequently Asked Questions
          </h2>
          <p className="text-gray-600 max-w-2xl mx-auto" data-id="element-191">
            Find answers to common questions about our essential oils and
            services.
          </p>
        </div>
        <div className="grid md:grid-cols-12 gap-10" data-id="element-192">
          {/* Image column */}
          <div className="md:col-span-5 order-2 md:order-1" data-id="element-193">
            <div className="relative rounded-2xl overflow-hidden shadow-lg" data-id="element-194">
              <img src="https://images.unsplash.com/photo-1608571423902-eed4a5ad8108?q=80&w=600&auto=format&fit=crop" alt="Essential oils" className="w-full h-full object-cover" onError={e => {
              e.currentTarget.src = 'https://images.unsplash.com/photo-1595981267035-7b04ca84a82d?q=80&w=600&auto=format&fit=crop';
            }} data-id="element-195" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent" data-id="element-196">
                <div className="absolute bottom-6 left-6 right-6" data-id="element-197">
                  <div className="bg-white/90 backdrop-blur-sm rounded-lg p-4 shadow-lg" data-id="element-198">
                    <p className="font-medium text-gray-900" data-id="element-199">
                      Still have questions?
                    </p>
                    <p className="text-sm text-gray-600 mt-1" data-id="element-200">
                      Contact our customer support team for personalized
                      assistance.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* FAQ column */}
          <div className="md:col-span-7 order-1 md:order-2" data-id="element-201">
            <div className="space-y-4" data-id="element-202">
              {faqs.map((faq, index) => <div key={index} className={`border rounded-xl overflow-hidden transition-all duration-200 ${openIndex === index ? 'border-[#2e7d32] shadow-md bg-white' : 'border-gray-200 bg-white hover:border-gray-300'}`} data-id="element-203">
                  <button className="flex justify-between items-center w-full p-5 text-left focus:outline-none" onClick={() => toggleFaq(index)} data-id="element-204">
                    <span className="font-medium text-gray-900" data-id="element-205">
                      {faq.question}
                    </span>
                    <div className={`flex-shrink-0 ml-4 p-1 rounded-full ${openIndex === index ? 'bg-[#f0f7eb]' : 'bg-gray-100'}`} data-id="element-206">
                      {openIndex === index ? <ChevronUpIcon className="h-5 w-5 text-[#2e7d32]" data-id="element-207" /> : <ChevronDownIcon className="h-5 w-5 text-gray-500" data-id="element-208" />}
                    </div>
                  </button>
                  <div className={`transition-all duration-300 overflow-hidden ${openIndex === index ? 'max-h-96' : 'max-h-0'}`} data-id="element-209">
                    <div className="p-5 pt-0 border-t border-gray-100" data-id="element-210">
                      <p className="text-gray-600" data-id="element-211">{faq.answer}</p>
                    </div>
                  </div>
                </div>)}
            </div>
          </div>
        </div>
      </div>
    </section>;
};
export default FaqSection;